import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { icons } from '../assets';
import {
  ActionFilters,
  BigButton,
  Checkbox,
  CircularProgress,
  DeactivatePopup,
  TopButtonArea,
} from '../common';
import PageTitle from '../common/PageTitle';
import { PageSearchBar } from '../common/UniversalSearchForm/UniversalSearchForm';
import { DELETE_ICON } from '../constants/assetConstants';
import {
  CARD_TYPE,
  RENDER_STATUS_OPTIONS,
  STATUS_DISABLED,
  STATUS_FAILED,
  STATUS_NOT_DONE,
} from '../constants/constants';
import { checkIfEmailIsVerifiedOrNot, useUserContext } from '../contexts/UserContext';
import { useScreenSettings } from '../helpers/configureHelper';
import { handleScrollToTop, setTitle } from '../helpers/jsHelper';
import { useAutomationDetails } from '../hooks/useAutomationDetails';
import { Breadcrumbs, CommonGrid } from '../layouts';
import styles from './AutomationDetails.module.scss';
import Table from 'react-bootstrap/Table';
import { Placeholder } from '../common/TransactionHistory/Placeholder';
import { SkeletonUI } from '../skeletonLoaderUI/SkeletonLoaderUI';
import format from 'date-fns/format';
import { Pagination } from '../common/Pagination/Pagination';
import Switch from '../components/admin/switch';
import UserIcon from '../components/icons/UserIcon';
import UploadFileDialog from '../common/UploadFileDialog/UploadFileDialog';
import AutomationTemplateImages from './AutomationTemplateImages';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ADMIN_DASHBOARD,
  AUTOMATION_EXCEL_HISTORY,
  AUTOMATION_ROUTE_V2,
} from '../constants/routePathConstants';
import AutomationTemplateInfo from '../common/Automation/AutomationTemplateInfo';
import { download } from '../common/DownloadFileController/downloadFile';
import { DOWNLOAD_SAMPLE_EXCEL_API } from '../config/constant/apiConstant';
import {
  apiCreateTemplatePreview,
  apiEnableTemplateRender,
  apiGetAutomation,
  apiDeleteTemplate,
  apiGetDownloadRendersImagesV2,
  apiRetryRenderPreview,
  apiUploadAutomationTemplateFile,
  apiGetAutomationExcels,
} from '../helpers/api';

import { RENDER_STATUS } from '../constants/constants';
import { errorToast, multiInfoToast, successToast, warningToast } from '../helpers/toastHelper';
import { PER_PAGE_OPTIONS } from '../constants/projectConstants';
import { RiImageLine } from 'react-icons/ri';
import { paginatedAutomationDetailsActions } from '../redux/slicers/automation/paginatedAutomationDetails';
import { useDispatch, useSelector } from 'react-redux';
import RenderDetails from './RenderDetails';
import { RefreshIcon } from '../components/icons/RefreshIcon';
import { history } from '../history';
import { getCuratorAutomationPath, getMultipleResponseList } from '../helpers/urlHelper';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { useStaticPermissions } from '../hooks/usePermissions';
import { PERMISSION } from '../constants/permissionConstants';
import { selectHasAutomationsData } from '../redux/slicers/subscriptionSlicer';
import { MxEvent } from '../common/Mixpanel';
import TopContainerV2 from '../layouts/TopContainerV2';
import FooterOptions from '../layouts/FooterOptions';
const { DownloadIcon, InfoIcon, UploadIcon, EditIcon, RetryIcon } = icons;

export const uploadAutomationExcelFile = (
  automationId,
  memberId,
  orgId,
  excelFiles,
  setUploadsLoading,
  setUploadFileModalStatus,
  reFetchData,
  getAutomationExcels,
  resetFiles
) => {
  if (excelFiles?.length) {
    setUploadsLoading?.(true);

    const uploadedFileStatus = excelFiles?.map((a) => {
      return { name: a.name, status: false };
    });

    Promise.all(
      excelFiles?.map(async (a, i) => {
        const formData = new FormData();
        formData.append('member', memberId);
        formData.append('organisation', orgId);
        formData.append('automation', automationId);
        formData.append('file', a);

        try {
          const res = await apiUploadAutomationTemplateFile(
            formData,
            `File "${a?.name}" uploaded successfully.`,
            'Uploaded'
          );

          if (res && res?.automation_action_file && res?.automation_action_file?.id) {
            uploadedFileStatus[i] = {
              ...uploadedFileStatus[i],
              id: res?.automation_action_file?.id,
              status: true,
            };
          }
        } catch (error) {
          let msg = '';

          if (typeof error?.message === 'object') {
            const objResponse = error?.message;

            Object.keys(objResponse).map((key, i) => {
              if (i !== 0) return;
              if (typeof objResponse[key] === 'string') {
                msg += objResponse[key] + '\n';
              } else if (Array.isArray(objResponse[key])) {
                msg += objResponse[key].join(', ');
              }
            });
          } else if (typeof error?.message === 'string') {
            msg = error?.message;
          } else {
            msg = `There was an issue uploading ${a?.name} file`;
          }

          errorToast(`${a?.name}: ${msg}`);
          setUploadsLoading?.(false);
          reFetchData?.();
          // setUploadFileModalStatus?.(false);
        }
      })
    )
      .then((res) => {
        if (
          excelFiles.length === uploadedFileStatus.length &&
          uploadedFileStatus.every((a) => a.status)
        ) {
          setUploadFileModalStatus?.(false);
          setUploadsLoading?.(false);
          reFetchData?.();
          getAutomationExcels();
          resetFiles();
        } else {
          resetFiles(uploadedFileStatus.map((a) => a?.status && a?.name));
        }
      })
      .catch((error) => {
        setUploadFileModalStatus?.(false);
        setUploadsLoading?.(false);
      });
  }
};

export const canDisableRender = (status) => {
  return [RENDER_STATUS.STATUS_PROCESSING, RENDER_STATUS.STATUS_DONE].includes(status);
};

export const isRenderDisabled = (status) => {
  if (isNaN(status)) return true;
  return [RENDER_STATUS.STATUS_DISABLED].includes(status);
};

export const isRenderStartedOrProcessingOrDone = (status) => {
  return [
    RENDER_STATUS.STATUS_NOT_DONE,
    RENDER_STATUS.STATUS_PROCESSING,
    RENDER_STATUS.STATUS_DONE,
  ].includes(parseInt(status));
};

const deleteParamsFromUrl = (paramKey) => {
  const params = new URLSearchParams(location.search);
  if (params.has(paramKey)) {
    params.delete(paramKey);
    history.replace({
      search: params.toString(),
    });
  }
};

const TEMPLATE_TYPE = {
  RENDER: 'render',
  PREVIEW: 'preview',
};
const TEMPLATE_RENDER_STATUS = {
  ENABLE: 'enable',
  DISABLE: 'disable',
};
const LOADING = {
  DELETE: 'delete',
  ENABLE_RENDERING: 'enableRendering',
  DISBALE_RENDERING: 'disableRendering',
  DOWNLOAD_RENDER: 'downloadImages',
  DOWNLOAD_PREVIEW: 'downloadPreviews',
  START_PREVIEW: 'startPreviews',
  DOWNLOAD_EXCEL: 'downloadExcel',
};

export default function AutomationDetails({
  cardType = CARD_TYPE.AUTOMATION_DETAILS,
  useGlobalSearch,
  apiConfig = {},
}) {
  const { id: automationId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openInfoDialog } = useInfoDialogaActions();
  const { currentUser, isFreemiumUser } = useUserContext();
  const currentMemberId = currentUser.id;

  const pageSettings = useScreenSettings(cardType);
  const {
    sortOptions,
    filterOptions: statusFilterOptions,
    defaultFilterOption: statusDefaultFilterOption,
    defaultSortOption,
  } = pageSettings;

  const [sortBy, setSortBy] = useState(defaultSortOption);
  const [status, setStatus] = useState(statusDefaultFilterOption);
  const [excel, setExcel] = useState({ label: 'Select Excel', value: '' });
  const [excelListData, setExcelListData] = useState([]);
  const [renderData, setRenderData] = useState(null);
  const [showTemplateInfo, setShowTemplateInfo] = useState(null);
  const [automationData, setAutomationData] = useState('');

  const { hasPermission } = useStaticPermissions();
  const hasAutomationData = useSelector(selectHasAutomationsData);

  const userCtx = useUserContext();
  const { token } = userCtx;
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);

  const requestParams = useMemo(
    () => ({
      ...apiConfig.requestParams,
      sort: sortBy?.value,
      id: automationId,
      ...((status?.value === 0 || status?.value) && {
        status: status?.value === RENDER_STATUS.STATUS_DISABLED ? 'none' : status?.value,
      }),
      ...(excel?.value && { excel_id: excel?.value }),
    }),
    [currentMemberId, apiConfig.requestParams, sortBy?.value, status?.value, excel?.value]
  );

  const {
    list,
    loading,
    total,
    hasData,
    selected,
    allSelected,
    toggleAll,
    fetchData,
    search,
    onSearchChange,
    perPage = 10,
    page = 1,
    onPageChange,
    onPerPageChange,
    toggleItem,
  } = useAutomationDetails({
    requestParams,
    useGlobalSearch,
  });

  useEffect(() => {
    handleScrollToTop(500)
  }, []);
  
  useEffect(() => {
    if (!hasAutomationData && !hasPermission(PERMISSION.CAN_CREATE_AUTOMATION)) {
      // if(isFreemiumUser()) {
      navigate(ADMIN_DASHBOARD);
      return null;
    }
  }, [hasAutomationData]);

  const [isLoading, setIsLoading] = useState([]);

  const [isUploading, setIsUploading] = useState(false);

  const PlaceholderLoadingComponent = loading ? SkeletonUI : Placeholder;
  const placeholderList = [...Array(10)];
  const showPlaceholders = loading || !list.length;

  const getAutomationData = async () => {
    const res = await apiGetAutomation(automationId);
    if (res && res?.id) {
      setTitle(res?.name);
      setAutomationData(res);
    }
  };

  const getAutomationExcels = async () => {
    const res = await apiGetAutomationExcels(automationId);
    if (res?.results) {
      setExcelListData(
        res.results.map((item) => ({ label: item.name, value: item.id, id: item.id }))
      );
    }
  };

  useEffect(() => {
    getAutomationData();
    getAutomationExcels();
  }, []);

  const isOldObj = automationData?.is_old_obj;

  const findDataFromList = (_id) => list.find((a) => a.id === _id);

  const checkIsLoading = (_id, type) =>
    isLoading.find((a) => {
      if (a.id === _id && a.type === type) {
        return a.loading;
      }
      return false;
    });

  const checkIsLoadingByType = (type) =>
    isLoading.some((a) => {
      if (a.type === type) return a.loading;
      return false;
    });

  const startLoading = (itemList = [], loadingType) => {
    setIsLoading((prevLoading) => [
      ...prevLoading,
      ...itemList.map((a) => {
        const isExists = prevLoading.find((b) => b.id === a.id && b.type === loadingType);
        if (isExists) {
          return {
            ...isExists,
            loading: true,
          };
        }

        return {
          id: a.id,
          loading: true,
          type: loadingType,
        };
      }),
    ]);
  };

  const stopLoading = (itemList = [], loadingType) => {
    setIsLoading((prevLoading) => [
      ...prevLoading.map((a) => {
        if (itemList.find((b) => b.id === a.id) && a.type === loadingType) {
          return {
            ...a,
            loading: false,
          };
        }

        return a;
      }),
    ]);
  };

  const getFormattedDateTime = (_date = null) => {
    const date = _date ? new Date(_date) : new Date();
    const hour = date.getHours() > 12 ? 'PM' : 'AM';
    return `${format(date, 'MMM dd, yyyy, hh:mm')} ${hour}`;
  };

  const handleDownloadClick = async () => {
    const downloadArr = [{ id: automationId }];
    startLoading(downloadArr, LOADING.DOWNLOAD_EXCEL);
    await download({
      fileUrl: `${DOWNLOAD_SAMPLE_EXCEL_API}?automation_id=${automationId}`,
      fileName: automationData.name,
      auth: token,
    });
    stopLoading(downloadArr, LOADING.DOWNLOAD_EXCEL);
  };

  const handleCreatePreview = async (_id) => {
    if (!checkIfEmailIsVerifiedOrNot()) return;

    var formData = new FormData();

    const selectedObjects = _id
      ? [findDataFromList(_id)]
      : selected.map((a) => {
          return findDataFromList(a);
        });

    const tempForPreview = selectedObjects.filter(
      (a) => !a?.preview && !isRenderStartedOrProcessingOrDone(a.render_status)
    );

    if (!tempForPreview?.length) {
      const message = `You can\'t preview the previewed/rendered data.`;
      warningToast(message);
      return;
    }

    tempForPreview.forEach((a) => formData.append('automation_action_ids', a.id));

    if (tempForPreview?.length) {
      startLoading(tempForPreview, LOADING.START_PREVIEW);

      const res = await apiCreateTemplatePreview(formData);

      stopLoading(tempForPreview, LOADING.START_PREVIEW);

      if (!res?.status) {
        errorToast(res?.message);
        return;
      }

      const responseData = res?.data?.automation_response_data
        ? Object.values(res?.data?.automation_response_data)
        : [];

      const updatedItems = tempForPreview.map((a) => {
        const data = responseData?.find((b) => b.id === a.id);

        return {
          ...a,
          preview: data?.preview || a.preview || null,
          assigned_date: getFormattedDateTime(),
          preview_status: `${data?.preview_status}` || null,
          preview_status_display: data?.preview_status_display || null,
        };
      });
      await dispatch(paginatedAutomationDetailsActions.updateAll(updatedItems));

      successToast('Templates are sent for preview.');
    }
  };

  const handleRenderToggle = (_id) => {
    const render = findDataFromList(_id);
    const status = parseInt(render?.render_status);

    if (!render) return;

    if (render?.render && canDisableRender(status)) {
      const message = `You can\'t disable it as render is in Processing/Done/Failed.`;
      warningToast(message);
      return;
    }

    // you reach here - it means you can either do enable/disable render
    if (!isRenderEnabled(_id)) {
      handleEnableDisableRendering(_id, TEMPLATE_RENDER_STATUS.ENABLE);
    } else {
      handleEnableDisableRendering(_id, TEMPLATE_RENDER_STATUS.DISABLE);
    }
  };

  const isRenderEnabled = (_id) => {
    const render = findDataFromList(_id);
    return (
      render?.render_status && parseInt(render?.render_status) !== RENDER_STATUS.STATUS_DISABLED
    );
  };

  const handleEnableDisableRendering = async (_id, enableOrDisable) => {
    if (!checkIfEmailIsVerifiedOrNot()) return;

    var formData = new FormData();

    const isEnable = enableOrDisable === TEMPLATE_RENDER_STATUS.ENABLE;

    const selectedObjects = _id
      ? [findDataFromList(_id)]
      : selected.map((a) => {
          return findDataFromList(a);
        });

    const tempForRender = isEnable
      ? selectedObjects.filter((a) => !a?.render)
      : selectedObjects.filter((a) => parseInt(a?.render_status) === RENDER_STATUS.STATUS_NOT_DONE);

    if (!tempForRender?.length) {
      const message = `You can\'t enable/disable it as render is in Processing/Done/Failed.`;
      warningToast(message);
      return;
    }

    const key = isEnable ? 'enable_rendering' : 'disable_rendering';

    tempForRender.forEach((a) => formData.append(key, a.id));

    if (tempForRender?.length) {
      startLoading(tempForRender, isEnable ? LOADING.ENABLE_RENDERING : LOADING.DISBALE_RENDERING);

      const res = await apiEnableTemplateRender(formData, null, null, null, () => {
        stopLoading(tempForRender, isEnable ? LOADING.ENABLE_RENDERING : LOADING.DISBALE_RENDERING);
      });

      if (!res?.status) {
        errorToast(res?.message);
        return;
      }

      const responseData = res?.data?.automation_response_data
        ? Object.values(res?.data?.automation_response_data)
        : [];

      const updatedItems = tempForRender.map((a) => {
        return {
          ...a,
          render: isEnable ? responseData?.find((b) => b.id === a.id)?.render || a.render : null,
          assigned_date: isEnable ? getFormattedDateTime() : null,
          render_status: isEnable
            ? `${RENDER_STATUS.STATUS_NOT_DONE}`
            : `${RENDER_STATUS.STATUS_DISABLED}`,
          render_status_display: isEnable ? STATUS_NOT_DONE : STATUS_DISABLED,
        };
      });
      await dispatch(paginatedAutomationDetailsActions.updateAll(updatedItems));

      const renderList = [
        {
          id: tempForRender.length,
          name: isEnable
            ? `${tempForRender.length} job${
                tempForRender.length > 1 ? 's are' : ' is'
              } sent for rendering`
            : `${tempForRender.length} job${tempForRender.length > 1 ? 's are' : ' is'} stopped`,
          status: isEnable,
          reason: null,
          action: '',
        },
      ];

      multiInfoToast(
        renderList,
        'Render status',
        <span dangerouslySetInnerHTML={{ __html: res?.data?.detail || res?.message }} />
      );
    }
  };

  const handleRetry = async (_id) => {
    const render = findDataFromList(_id);

    await apiRetryRenderPreview(render?.render);

    const updateRender = {
      ...render,
      assigned_date: getFormattedDateTime(),
      render_status: `${RENDER_STATUS.STATUS_NOT_DONE}`,
      render_status_display: STATUS_NOT_DONE,
    };

    await dispatch(paginatedAutomationDetailsActions.update(updateRender));
  };

  const handleFileImport = async (values, resetFiles) => {
    await uploadAutomationExcelFile(
      automationId,
      currentMemberId,
      currentUser?.organization,
      values,
      setIsUploading,
      setShowUploadFileModal,
      fetchData,
      getAutomationExcels,
      resetFiles
    );
  };

  const handleMutipleImagesDownload = async (_type) => {
    var selectedObjects = selected.map((_id) => findDataFromList(_id));

    selectedObjects = selectedObjects?.filter((a) =>
      _type === TEMPLATE_TYPE.RENDER
        ? parseInt(a.render_status) === RENDER_STATUS.STATUS_DONE
        : parseInt(a.preview_status) === RENDER_STATUS.STATUS_DONE
    );

    if (!selectedObjects.length) {
      warningToast('Images are not ready yet.');
      return;
    }

    if (selectedObjects.length > 50) {
      warningToast('You are not allowed to download more than 50 images.');
      return;
    }

    const selectedIds = selectedObjects?.map((a) =>
      _type === TEMPLATE_TYPE.RENDER ? a.render : a.preview
    );

    let fileName = `${automationData?.name}.zip`;
    if (selectedIds.length === 1) {
      const key = _type === TEMPLATE_TYPE.RENDER ? 'render' : 'preview';
      const obj = selectedObjects?.find((a) => a[key] === selectedIds?.[0]);
      fileName = `${obj?.name}.zip`;

      downloadMultipleImages({ _type, selectedIds, selectedObjects, fileName, is_separate: false });
      return;
    }

    openInfoDialog({
      title: 'Do you want a separate folder for each template?',
      cancelButtonText: 'No',
      cancelBtnColor: 'outline-dark',
      okBtnColor: 'warning',
      buttonText: 'Yes',
      onButtonClick: () =>
        downloadMultipleImages({
          _type,
          selectedIds,
          selectedObjects,
          fileName,
          is_separate: true,
        }),
      onCancelClick: () =>
        downloadMultipleImages({
          _type,
          selectedIds,
          selectedObjects,
          fileName,
          is_separate: false,
        }),
    });
  };

  const downloadMultipleImages = async ({
    _type,
    selectedIds,
    selectedObjects,
    fileName,
    is_separate,
  }) => {
    startLoading(
      selectedObjects,
      _type === TEMPLATE_TYPE.RENDER ? LOADING.DOWNLOAD_RENDER : LOADING.DOWNLOAD_PREVIEW
    );

    successToast('Please wait while we prepare your images.');

    await apiGetDownloadRendersImagesV2({
      ids: selectedIds.filter((a) => a),
      fileName: fileName,
      is_separate,
    });

    stopLoading(
      selectedObjects,
      _type === TEMPLATE_TYPE.RENDER ? LOADING.DOWNLOAD_RENDER : LOADING.DOWNLOAD_PREVIEW
    );
  };

  const deleteCallback = (response) => {
    if (!response) return;

    const updateResponse = {};
    Object.entries(response).forEach((a) => {
      const val = {
        ...a[1],
        action: a[1].message,
      };
      updateResponse[a[0]] = val;
    });

    multiInfoToast(
      getMultipleResponseList(
        updateResponse,
        selected.map((a) => findDataFromList(a))
      ),
      'Delete details'
    );
  };

  const handleDeleteClick = async () => {
    const formData = new FormData();
    let formHasData = false;
    selected.forEach((_id) => {
      if (parseInt(findDataFromList(_id)?.render_status) !== RENDER_STATUS.STATUS_DONE) {
        formData.append('id', _id);
        formHasData = true;
      }
    });

    if (formHasData) {
      const res = await apiDeleteTemplate(formData, automationId, null, null, '', deleteCallback);

      if (res && res?.status) {
        deleteCallback(res?.data);
      }

      fetchData();
    } else {
      warningToast('Done templates cannot be deleted.');
    }
  };

  const handleUploadButton = () => {
    openInfoDialog({
      title: automationData.name,
      description:
        'It is an older version of automation file. You can still use it by opening it in curator and reuploading it as a new automation. Once you open the file, all automation data will be automatically populated. You will just need to hit on create automation button.',
      cancelButtonText: 'Cancel',
      cancelBtnColor: 'outline-dark',
      okBtnColor: 'warning',
      buttonText: 'Open',
      onButtonClick: () => window.open(getCuratorAutomationPath('open', automationId), '_blank'),
    });
  };

  useEffect(() => {
    if (status) {
      setStatus(status);
    }
    if (excel) {
      setExcel(excel);
    }
  }, [status, excel]);

  const breadcrumbs = [
    {
      link: AUTOMATION_ROUTE_V2,
      label: 'Automation',
      mx_event: MxEvent.VISITED_AUTOMATION,
    },
    {
      label: automationData?.name,
    },
  ];

  return (
    <>
      {breadcrumbs && <Breadcrumbs classNames="breadcrumbHeadeV2" fullWidth list={breadcrumbs} />}
      <CommonGrid
        subClassName="automation-container"
        hiddenTab
        className={(selected?.length || allSelected) ? 'show-action-footer' : ''}
        topContainer={
          <>
            <TopContainerV2 hiddenTab>
              <h5 className="title">{automationData?.name}</h5>
              <div className="d-flex justify-content-between align-items-center ms-auto">
                <div className="top-buttons align-self-center d-flex">
                  {automationData.is_old_obj ? (
                    <BigButton
                      bigBtnClass="lf-btn-1 opacity-75 black-btn"
                      buttonTitle="Upload excel file"
                      iconBefore={<UploadIcon />}
                      onClick={handleUploadButton}
                    />
                  ) : (
                    <UploadFileDialog
                      isLoading={isUploading}
                      showModal={showUploadFileModal}
                      setShowModal={setShowUploadFileModal}
                      handleFileImport={handleFileImport}
                      buttonTitle="Upload excel file"
                      iconBefore={<UploadIcon />}
                    />
                  )}
                  <BigButton
                    bigBtnClass="lf-btn-1 black-btn keep-text"
                    isLoading={checkIsLoadingByType(LOADING.DOWNLOAD_EXCEL)}
                    buttonTitle="Download sample file"
                    iconBefore={<DownloadIcon />}
                    onClick={handleDownloadClick}
                  />
                  <BigButton
                    bigBtnClass="lf-btn-1 black-btn keep-text"
                    buttonTitle="View excel file"
                    onClick={() => navigate(AUTOMATION_EXCEL_HISTORY.replace(':id', automationId))}
                  />
                </div>
              </div>
            </TopContainerV2>

            <TopContainerV2 hiddenTab subClassName="justify-content-start">
              <PageSearchBar onSearchChange={onSearchChange} search={search} hideTags={true} />
              <ActionFilters
                className="gap-0"
                loading={loading}
                sortProps={{
                  value: sortBy,
                  data: sortOptions,
                  onChange: setSortBy,
                  containerClass: 'top-filter',
                }}
                filterProps={{
                  value: status.value,
                  data: statusFilterOptions,
                  onChange: (e) => setStatus(e),
                  placeholder: status.label,
                  containerClass: 'top-filter',
                }}
              />
              <ActionFilters
                filterProps={{
                  value: excel,
                  data: [{ label: 'Select Excel', value: '' }, ...excelListData],
                  onChange: (e) => setExcel(e),
                  placeholder: excel.label,
                  containerClass: 'top-filter',
                }}
              />
            </TopContainerV2>
          </>
        }
        noDataText=" "
        item={cardType}
        hasData={list.length > 0 || loading}
        list={list}
        filterArea={<div className="d-flex"></div>}>
        <div className="table-responsive">
          <Table striped bordered className={`basic-table ${styles.table}`}>
            <thead className={`basic-table-head ${styles.tableHead}`}>
              <tr>
                <th>
                  <Checkbox selected={allSelected} onChange={toggleAll} />
                </th>
                <th>
                  <div>#</div>
                </th>
                <th>
                  <div>ID</div>
                </th>
                <th>
                  <div>Template Name</div>
                </th>
                <th>
                  <div>Assigned Date</div>
                </th>
                <th>
                  <div>Render Status</div>
                </th>
                <th>
                  <div>Enable/Disable</div>
                </th>
                <th>
                  <div>Render Images</div>
                </th>
                <th>
                  <div>Preview</div>
                </th>
                <th>
                  <div>Info</div>
                </th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {showPlaceholders
                ? placeholderList.map((_, idx) => (
                    <tr key={idx}>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                      <td>
                        <PlaceholderLoadingComponent maxWidth="100%" />
                      </td>
                    </tr>
                  ))
                : list?.map((item, index) => {
                    const formattedDate = item?.assigned_date
                      ? getFormattedDateTime(item?.assigned_date)
                      : '-';

                    let renderStatus = item?.render_status_display || STATUS_DISABLED;
                    if (
                      item?.render &&
                      item?.render_status &&
                      parseInt(item?.render_status) === RENDER_STATUS.STATUS_FAILED
                    ) {
                      renderStatus = (
                        <>
                          <span
                            className="d-flex gap-2"
                            style={{
                              color: 'var(--error)',
                            }}>
                            {renderStatus}{' '}
                            <RefreshIcon
                              title="Retry this render"
                              style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                              onClick={() => handleRetry(item?.id)}
                            />
                          </span>
                        </>
                      );
                    }

                    return (
                      <tr key={index}>
                        <td>
                          <Checkbox
                            selected={selected?.includes(item?.id)}
                            onChange={() => toggleItem(item?.id)}
                            style={{ cursor: 'pointer' }}
                          />
                        </td>
                        <td>{perPage * (page - 1) + (index + 1)}</td>
                        <td>{item?.id}</td>
                        <td>{item?.name}</td>
                        <td>{formattedDate}</td>
                        <td>{renderStatus}</td>
                        <td>
                          {checkIsLoading(
                            item.id,
                            isRenderEnabled(item.id)
                              ? LOADING.DISBALE_RENDERING
                              : LOADING.ENABLE_RENDERING
                          ) ? (
                            <CircularProgress size={14} thickness={1} />
                          ) : (
                            <Switch
                              containerClassName="dark d-flex"
                              checked={
                                checkIfEmailIsVerifiedOrNot(false)
                                  ? isRenderEnabled(item.id)
                                  : false
                              }
                              onToggle={(e) => handleRenderToggle(item.id)}
                              labelStyle={isOldObj ? { pointerEvents: 'none' } : {}}
                            />
                          )}
                        </td>
                        <td>
                          {item?.render && item?.render_status ? (
                            <div
                              className="d-flex align-items-center"
                              style={{
                                cursor: 'pointer',

                                ...(item?.is_archive_render
                                  ? {
                                      color: 'var(--error)',
                                    }
                                  : {}),
                              }}
                              onClick={() =>
                                setRenderData({
                                  id: item?.render,
                                  type: TEMPLATE_TYPE.RENDER,
                                  status: item?.is_archive_render ? 'archive' : '',
                                })
                              }>
                              <RiImageLine
                                fontSize={24}
                                className={'placeholderIcon'}
                                style={{ cursor: 'pointer' }}
                              />
                              {item?.is_archive_render && <span>&nbsp;&nbsp;Archived</span>}
                            </div>
                          ) : (
                            <span className="fw-bold">No images</span>
                          )}
                        </td>
                        <td>
                          {item?.preview && item?.preview_status ? (
                            item?.is_deleted_preview ? (
                              <span style={{ color: 'var(--error)' }}>Deleted</span>
                            ) : (
                              <RiImageLine
                                fontSize={24}
                                className={'placeholderIcon'}
                                onClick={() =>
                                  setRenderData({ id: item?.preview, type: TEMPLATE_TYPE.PREVIEW })
                                }
                                style={{ cursor: 'pointer' }}
                              />
                            )
                          ) : isRenderDisabled(parseInt(item?.render_status)) ? (
                            checkIsLoading(item.id, LOADING.START_PREVIEW) ? (
                              <CircularProgress size={14} thickness={1} />
                            ) : (
                              <div
                                className={styles.createPreviewText}
                                onClick={() => handleCreatePreview(item.id)}>
                                Create
                              </div>
                            )
                          ) : (
                            <div>No Images</div>
                          )}
                        </td>
                        <td>
                          <InfoIcon
                            onClick={() => setShowTemplateInfo(item)}
                            className={styles.infoIcon}
                          />
                        </td>
                      </tr>
                    );
                  })}

              {showPlaceholders && !loading && (
                <div className={styles.noDataFoundText}>No templates found</div>
              )}
            </tbody>
            {/* </div> */}
          </Table>
        </div>

        {total > 10 && (
          <Pagination
            perPage={perPage}
            currentPage={page}
            totalItems={total}
            onPageChange={onPageChange}
            perPageOptions={PER_PAGE_OPTIONS}
            onPerPageChange={onPerPageChange}
          />
        )}

        {renderData ? (
          <RenderDetails
            id={renderData?.id}
            onClose={() => {
              deleteParamsFromUrl('cameraName');
              setRenderData(null);
              setTitle(automationData?.name);
              fetchData();
            }}
            onDeleteSuccess={() => {
              setRenderData(null);
              fetchData();
            }}
            previewProps={{ className: styles.renderBody }}
            sidebarProps={{ className: styles.renderSidebar }}
            hideAutoEraseWarning={renderData.type === TEMPLATE_TYPE.RENDER || false}
            renderStatusType={renderData?.status || ''}
            isAutomation={true}
          />
        ) : null}

        {showTemplateInfo && (
          <AutomationTemplateInfo
            automationData={showTemplateInfo}
            show={!!showTemplateInfo}
            setShow={() => setShowTemplateInfo(null)}
            title={showTemplateInfo?.name}
            isTemplateInformation={true}
          />
        )}

        {(selected?.length || allSelected) && (
          <FooterOptions>
            <>
              <div className="selected-item">
                <ActionFilters
                  selectedProps={
                    list?.length > 0 && {
                      allSelected: allSelected,
                      onSelectAll: () => toggleAll(),
                    }
                  }
                />
                <span>{selected?.length || 0} Selected</span>
              </div>
              <div className="footer-action">
            
                  <TopButtonArea
                    hasData={hasData}
                    item={cardType}
                    topButtonList={[
                      {
                        element: DeactivatePopup,
                        bigButton: true,
                        bigBtnClass: 'lf-btn-3 keep-text',
                        isPlural: true,
                        iconSrc: DELETE_ICON,
                        deleteAction: handleDeleteClick,
                        isLoading: checkIsLoadingByType(LOADING.DELETE),
                        item: cardType,
                        onSuccess: fetchData,
                        actionWord: 'delete',
                        subtitle: 'Your templates will be deleted permanently.',
                        disabled: isOldObj,
                      },
                      {
                        element: BigButton,
                        bigBtnClass: 'lf-btn-1 keep-text',
                        isLoading: checkIsLoadingByType(LOADING.ENABLE_RENDERING),
                        buttonTitle: 'Enable Rendering',
                        onClick: (id) =>
                          handleEnableDisableRendering(id, TEMPLATE_RENDER_STATUS.ENABLE),
                        disabled: isOldObj,
                      },
                      {
                        element: BigButton,
                        bigBtnClass: 'lf-btn-2 keep-text',
                        isLoading: checkIsLoadingByType(LOADING.DISBALE_RENDERING),
                        buttonTitle: 'Disable Rendering',
                        onClick: (id) =>
                          handleEnableDisableRendering(id, TEMPLATE_RENDER_STATUS.DISABLE),
                        disabled: isOldObj,
                      },
                      {
                        element: BigButton,
                        bigBtnClass: 'lf-btn-1 keep-text',
                        isLoading: checkIsLoadingByType(LOADING.DOWNLOAD_RENDER),
                        buttonTitle: 'Download Images',
                        iconBefore: <DownloadIcon />,
                        onClick: () => handleMutipleImagesDownload(TEMPLATE_TYPE.RENDER),
                      },
                      {
                        element: BigButton,
                        bigBtnClass: 'lf-btn-1 keep-text',
                        isLoading: checkIsLoadingByType(LOADING.START_PREVIEW),
                        buttonTitle: 'Start Previews',
                        onClick: handleCreatePreview,
                        disabled: isOldObj,
                      },
                      {
                        element: BigButton,
                        bigBtnClass: 'lf-btn-1 keep-text',
                        isLoading: checkIsLoadingByType(LOADING.DOWNLOAD_PREVIEW),
                        buttonTitle: 'Download Previews',
                        iconBefore: <DownloadIcon />,
                        onClick: () => handleMutipleImagesDownload(TEMPLATE_TYPE.PREVIEW),
                      },
                    ]}
                    anySelected={selected?.length}
                    selectedList={selected}
                  />
             
              </div>
            </>
          </FooterOptions>
        )}
      </CommonGrid>
    </>
  );
}

const RenderPreviewImages = ({ onClick, images }) => {
  return (
    <div className="custom-imges user-icon-top " onClick={onClick}>
      <span style={{ display: 'flex' }}>
        {images?.map((item, index) =>
          index < 2 ? (
            <span className="avatar" style={{ cursor: 'pointer' }} key={index}>
              {item?.thumbnail ? <img src={item.thumbnail} /> : <UserIcon />}
            </span>
          ) : null
        )}
        {images?.length > 2 && (
          <span className="avatar avtar-count-part" style={{ cursor: 'pointer' }}>
            +{images?.length - 2}
          </span>
        )}
      </span>
    </div>
  );
};
